var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEnabled
    ? _c("accordion", {
        attrs: { id: _vm.accordionId, group: _vm.accordionGroup },
        scopedSlots: _vm._u(
          [
            {
              key: "trigger",
              fn: function() {
                return [
                  _c("span", {
                    staticClass: "icon-pita sw--margin-right-3 sw--font-size-20"
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Print it anyway (PITA)")])
                ]
              },
              proxy: true
            },
            {
              key: "target",
              fn: function() {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        " sw--margin-left-7 sw--margin-left-0--tab sw--margin-bottom-2 sw-dms--color-grey-46"
                    },
                    [
                      _vm._v(
                        "\n      We will print what you've designed, but this does mean that your 3D printed model may be in an imperfect state\n      when delivered. More information about Print it anyway can be found through our\n      "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://support.shapeways.com/hc/en-us/articles/360016884614-How-does-Print-It-Anyway-work-",
                            title: "How does 'Print It Anyway' work?",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Help Center")]
                      ),
                      _vm._v(".\n    ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sw--margin-bottom-7 sw--margin-left-7 sw--margin-left-0--tab"
                    },
                    [
                      _vm.errorMessage
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "model-fix-error-box\n          sw-grid-flex__cell\n          sw-grid-flex\n          sw-grid-flex--align-center\n          sw--padding-4\n          sw--bg-alert-red-lightest\n          sw--border-radius-3\n          sw--margin-vert-2"
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "icon-how-it-works sw--font-size-28 sw--margin-right-3 sw--text-red"
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.errorMessage) +
                                    "\n        "
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "sw-dms-button sw-dms-button--big",
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.displayModal(_vm.modalText)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "sw-dms--color-grey-46" }, [
                            _vm._v("\n            Print it anyway\n        ")
                          ])
                        ]
                      )
                    ]
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          false,
          3613287660
        )
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }